
import { cloneDeep } from '@/lib';
import { Checkbox, Col, Row } from 'ant-design-vue';
import {
  defineComponent, inject, ref, toRaw,
} from 'vue';

export default defineComponent({
  components: {
    aRow: Row,
    aCol: Col,
    aCheckbox: Checkbox,
    aCheckboxGroup: Checkbox.Group,
  },
  props: {
    /** 所有选项 */
    pMetas: {
      type: Array,
      default: () => ([]),
    },
    /** 正确选项 */
    pAnswer: {
      type: Array,
      default: () => ([]),
    },
    /** 学生答案 */
    stuAnswer: {
      type: Array,
      default: () => ([]),
    },
  },
  emits: ['onStuAnswer'],
  setup(props, { emit }) {
    const jobView = inject('jobView');
    const answer = ref(props.pAnswer);
    const todoStu = ref(props.stuAnswer);
    // console.log(props.stuAnswer, 'stuAnswer');
    const todoSave = () => {
      emit('onStuAnswer', cloneDeep(toRaw(todoStu.value)).sort());
    };
    return {
      jobView,
      answer,
      todoStu,
      todoSave,
    };
  },
});
